export default __webpack_public_path__ + "static/media/12.6e5cb259.png";